import axios from '../../functions/axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import style from './CarriageList2Print.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { parseDate } from '../../functions/functions';

export default function WeekView() {
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const initDate = parseDate(Date.parse(location.state?.date || sessionStorage.getItem('selectedWeek') || new Date())).monday;
  const [currentDate, setCurrentDate] = useState(initDate);
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const getCarriageData = async (date = currentDate) => {
    if (!user) return null;
    setLoading(true);
    try {
      const response = await axios.get(`/carriage`, {
        params: {
          startDate: parseDate(date).monday,
          endDate: parseDate(date).sunday,
        },
      });
      setApiData(response.data);
    } catch (error) {
      console.error(error.message);
    }
    setLoading(false);
  };


  useEffect(() => {
    (async () => {
      await getCarriageData();
      window.print();
      navigate('/CarriageList');
    })();
  }, [user]);

  if (isLoading || !apiData.length) {
    return <>{!apiData.length ? <div className={style.missingData}>Brak danych do wyświetlenia...</div> : null}</>;
  }

  const cars = [...new Set(apiData.map((data) => data.car?.plate))].sort((...args) => {
    const [a, b] = args.map((plate) => plate.toUpperCase());
    return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
  });

  return (
    <center>
      <div className={style.container}>
        <p>Tydzień: <span style={{ marginRight: '15px' }}>{parseDate(currentDate).week}</span> ({['monday', 'sunday'].map((day) => new Date(parseDate(currentDate)[day]).toLocaleDateString('pl')).join(' - ')})</p>
        <div className={style.mainHeader}>
          <span>Samochód</span>
          <span>Kierowca</span>
          <span>Data</span>
          <span>Z / Do</span>
{/*}          <span>Liczba km</span> */}
          <span>Stawka </span>
          <span>Faktura</span>
          <span>Termin płatności</span>
          <span>Dokumenty</span>
          {/* <span>Status wykonania</span> */}
          {/* <span>Wprowadził</span> */}
        </div>
        {cars
          .filter((plate) => {
            if (location.state.searchQuery === '') return true;
            return plate.toUpperCase().includes(location.state.searchQuery);
          })
          .map((plate) => (
            <div className={style.carWeek} key={plate}>
              <div className={style.plate}>{plate}</div>
              <div className={style.data}>
                {apiData
                  .filter((carriage) => carriage.car.plate === plate)
                  .sort((...args) => {
                    const [a, b] = args.map(({ day }) => Date.parse(day));
                    return a - b;
                  })
                  .map((carriage) => {
                    return (
                      <div className={style.carriageData} key={carriage._id}>
                        <div className={style.driver}>{carriage.driver?.name.split(' ').reduce((acc, element) => [acc, <br />, element]) || '-'}</div>
                        <div className={style.day}>{new Date(carriage.day).toLocaleDateString('pl')}</div>
                        <div className={style.route}>
                          <ul className={style.routeList}>
                            <li className={style.routeStart}>{carriage.routeStart || '-'}</li>
                            <li className={style.to}>{carriage.routeEnd || '-'}</li>
                          </ul>
                        </div>
                      {/*  <div className={style.status}>{carriage.counterEnd - carriage.counterStart}</div> */}
                        <div className={style.cost}>
                          {carriage.cost?.toLocaleString('pl-PL', { style: 'currency', currency: carriage.currency || 'EUR' }) || '-'}
                          <br />
                          {carriage.counterStart >= 0 && carriage.counterEnd
                            ? `(${(Math.round((carriage.cost / (carriage.counterEnd - carriage.counterStart)) * 100) / 100).toLocaleString('pl-PL', {
                              style: 'currency',
                              currency: carriage.currency || 'EUR',
                            })} / km)`
                            : '-'}
                        </div>
                        <div className={style.invoice}>{carriage.invoice || '-'}</div>
                        <div className={style.invoiceDate}>
                          {carriage.invoiceDate ? new Date(carriage.invoiceDate).toLocaleDateString('pl') : '- '}
                          <br />
                          {<input id='invoicePay' type='checkbox' name='invoicePay' checked={carriage.invoicePayment}onChange={() => { }} />}
                        </div>
                        <div className={style.doc}>{<input id='documentation' type='checkbox' name='documentation' checked={carriage.documentation} onChange={() => { }} />}</div>
                        {/* <div className={style.status}>{(carriage.counterStart >= 0 && carriage.counterEnd) ? 'Ukończono' : 'W trakcie realizacji'}</div> */}
                        {/* <span>
                          <img className={style.editButton} src={editButton} onClick={() => navigate('/editCarriage', { state: carriage })} />
                        </span> */}
                      </div>
                    );
                  })
                  .reduce((acc, element) => [acc, <hr className={style.customHr} />, element])}
              </div>
            </div>
          ))}
      </div>
    </center>
  );
}
